const { isSystemChatHead } = require('./insideChatHeader');

const INSIDE_CHAT_SHARE_ORIGIN = 'https://pixie.bigtapapp.com';

function sameId(left, right) {
  if (left == null || left === '' || right == null || right === '') return false;
  const a = Number(left);
  const b = Number(right);
  return Number.isFinite(a) && a === b;
}

/** Stable ids for the open chat head. Local chat ids are not shared. */
function insideChatShareTargetFromChat(chat) {
  if (!chat) return null;
  if (chat.groupId != null && chat.groupId !== '') {
    const groupId = Number(chat.groupId);
    if (!Number.isFinite(groupId)) return null;
    return { kind: 'group', groupId };
  }
  if (isSystemChatHead(chat)) return { kind: 'system' };
  const personId =
    chat.personId != null && chat.personId !== '' ? Number(chat.personId) : null;
  const userId =
    chat.userId != null && chat.userId !== '' ? Number(chat.userId) : null;
  if (
    (personId == null || !Number.isFinite(personId)) &&
    (userId == null || !Number.isFinite(userId))
  ) {
    return null;
  }
  return {
    kind: 'direct',
    personId: Number.isFinite(personId) ? personId : null,
    userId: Number.isFinite(userId) ? userId : null,
  };
}

function queryId(value) {
  if (value == null || value === '') return null;
  const raw = Array.isArray(value) ? value[0] : value;
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

function insideChatShareTargetFromQuery(query) {
  const q = query || {};
  const groupId = queryId(q.group);
  if (groupId != null) return { kind: 'group', groupId };
  const userId = queryId(q.user);
  const personId = queryId(q.person);
  if (userId === 0 && personId == null) return { kind: 'system' };
  if (personId == null && userId == null) return null;
  return { kind: 'direct', personId, userId };
}

function insideChatShareUrl(chat, origin) {
  const target = insideChatShareTargetFromChat(chat);
  if (!target) return '';
  const base = String(origin || INSIDE_CHAT_SHARE_ORIGIN).replace(/\/$/, '');
  if (target.kind === 'group') return `${base}/ichat?group=${target.groupId}`;
  if (target.kind === 'system') return `${base}/ichat?user=0`;
  const parts = [];
  if (target.personId != null) parts.push(`person=${target.personId}`);
  if (target.userId != null) parts.push(`user=${target.userId}`);
  return `${base}/ichat?${parts.join('&')}`;
}

function findChatForShareTarget(chats, target) {
  if (!target) return null;
  for (const chat of chats || []) {
    if (target.kind === 'group') {
      if (sameId(chat && chat.groupId, target.groupId)) return chat;
      continue;
    }
    if (target.kind === 'system') {
      if (isSystemChatHead(chat)) return chat;
      continue;
    }
    if (!chat || (chat.groupId != null && chat.groupId !== '')) continue;
    if (target.personId != null && !sameId(chat.personId, target.personId)) {
      continue;
    }
    if (target.userId != null && !sameId(chat.userId, target.userId)) continue;
    return chat;
  }
  return null;
}

module.exports = {
  INSIDE_CHAT_SHARE_ORIGIN,
  insideChatShareTargetFromChat,
  insideChatShareTargetFromQuery,
  insideChatShareUrl,
  findChatForShareTarget,
};
